// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "gf/css/" + chunkId + "." + "4618b4f3a70f9fc58952" + ".css";
};